import React from 'react'
import { Link } from 'react-router'
import PageTemplate from 'components/page-template'

import './index.css'

const NotFoundPage = () => (
  <PageTemplate
    title='Page not found'
    description='Got a bit lost there...'
    noContainer
    center
  >
    <div className='page-404'>
      <div className='number font-green'> 404 </div>
      <div className='details'>
        <h3>Oops! You&apos;re lost.</h3>
        <p>
          {' '}
          We can not find the page you&apos;re looking for.
          <br />
          <Link to={`/`}> Return home </Link>
        </p>
      </div>
    </div>
  </PageTemplate>
)

NotFoundPage.displayName = 'NotFoundPage'

export default NotFoundPage



// WEBPACK FOOTER //
// ./src/pages/not-found-page/index.js